import React, { useState } from 'react';
import { useTranslate } from 'react-admin';
import { Box, Dialog, DialogContent, DialogTitle, IconButton, Tooltip, Typography, useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { IconQrcode } from '@tabler/icons-react';
import { isSuperAdmin } from '../../helper/resourceHelper';
import ProvisioningTokens from '../../pages/device/provisioningTokens/ProvisioningTokens';


const ProvisioningTokensDialog = ({ open, setOpen }) => {
    const translate = useTranslate();
    const theme = useTheme();

    return (
        <Dialog
            open={open}
            onClose={() => { }}
            fullWidth
            maxWidth="sm"
            sx={{
                "& .MuiPaper-root": {
                    margin: "10px",
                    padding: "0px"
                }
            }}
        >
            <DialogTitle sx={{ display: "flex", flexDirection: 'row', justifyContent: "space-between", alignItems: "center", padding: "16px 12px 0px 20px" }}>
                <Typography sx={{ fontSize: "16px", fontWeight: 500, color: theme.palette.text.primary }}>{translate('resources.devices.provisioning_tokens.title')}</Typography>
                <IconButton aria-label="close" onClick={() => { setOpen(false); }} sx={{ color: theme.palette.text.secondary }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ padding: "20px" }}>
                <ProvisioningTokens onClose={() => { setOpen(false); }} />
            </DialogContent>
        </Dialog>
    )
}


const ProvisioningTokensButton = () => {
    const translate = useTranslate();
    const theme = useTheme();
    const [openDialog, setOpenDialog] = useState(false);

    if (!isSuperAdmin()) {
        return (null)
    }

    return (
        <Box sx={{
            padding: "0px",
            marginRight: { xs: "8px", lg: "20px" },
        }}>
            <Tooltip title={translate('resources.devices.provisioning_tokens.title')} disableInteractive>
                <IconButton
                    sx={{
                        padding: "3px",
                        border: `1.5px solid ${theme.palette.primary.main}`,
                        borderRadius: "8px",
                        '&:hover': {
                            backgroundColor: 'transparent'
                        }
                    }}
                    onClick={() => { setOpenDialog(true); }}
                >
                    <IconQrcode color={theme.palette.primary.main} size={24} stroke={2} />
                </IconButton>
            </Tooltip>
            {openDialog && <ProvisioningTokensDialog open={openDialog} setOpen={setOpenDialog} />}
        </Box>
    )
};


export default ProvisioningTokensButton;
